<section class="ac-flex-col ac-gap-xl">
  <div class="header ac-flex ac-sp-btw">
    @if (title) {
      <div class="ac-flex ac-algn-ctr ac-gap-sm">
        @if (iconKey) {
          <ac-icon [iconKey]="iconKey" [size]="24" />
        }
        <div [class]="titleClass">
          {{ title }}
        </div>
      </div>
    }

    <div class="nav-btns" [class]="{'hidden': hideNavButtons()}">
      @if (viewAllLink) { 
        @if (device.isXsScreen()) {
          <a class="ac-label ac-flex ac-algn-ctr ac-gap-sm" [routerLink]="viewAllLink">
            <span class="ac-label ac-title-sm">
              View All
            </span>
            <ac-icon iconKey="hr:arrow_right_circle" [size]="16" />
          </a>
        } @else {
          <button mat-flat-button class="carousel-btn view-all-btn" [routerLink]="viewAllLink">
            View&nbsp;All
          </button>
        }
      }

      <button #leftButton mat-flat-button class="carousel-btn left-btn" [class]="{'hidden': device.isXsScreen()}" (click)="scrollLeft()">
        <ac-icon iconKey="hr:arrow_left" [size]="18" />
      </button>

      <button #rightButton mat-flat-button class="carousel-btn right-btn" [class]="{'hidden': device.isXsScreen()}" (click)="scrollRight()">
        <ac-icon iconKey="hr:arrow_right" [size]="18" />
      </button>
    </div>
  </div>

  <div #carouselViewport class="carousel-viewport">
    <div class="carousel-container">
      <ng-content select="app-slide"></ng-content>
    </div>
  </div>
</section>
